

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getInsuranceData } from "../../../../../store/Api";
import { setBreadCrumb } from "../../../../../store/userSlice";
import ListNewInsurance from "../NewInsuranceApplication/ListNewInsurance";
import InsuranceCancellationList from "./InsuranceCancellationList";


export default function InsuranceCancellation() {
    const Client = useSelector((state) => state.insuranceData);
    const dispatch = useDispatch();

    //screen Title Show fun
    const titleBorder = [{ label: "Insurance", link: "/dashboard/Insurance" }];
    useEffect(() => {
        dispatch(setBreadCrumb(titleBorder));
    }, []);

    const [loading, setLoading] = useState({
        updateData: false,
        uploadFile: false,
        listData: false,
        loadingId: "",
    });
    const token = localStorage.getItem("nodeToken");

    const url = 'employee-insurance/insuranceCancel';
    useEffect(() => {
        dispatch(getInsuranceData({ token, url }));
    }, []);

    const updateData = () => {
        dispatch(getInsuranceData({ token, url }));
    };

    const [showPromptElement, setShowPromptElement] = useState({
        open: false,
    });

    return (
        <InsuranceCancellationList
            list={Client}
            loading={loading}
            titles={[
                "S.NO.",
                "NAME",
                "EFFECTIVE DATE",
                "INSURANCE INEFFECTIVE DATE",
                "NATIONALITY",
                "STAFF ID",
                "CLIENT CODE",
                "ID NO",
                "NEW ID",
                "RELATION",
                "GENDER",
                "MARITAL STATUS",
                "CLASS",
                "MOBILE NO",
                "SPONSOR NAME",
                "SPONSOR NO",
                "MEMBERSHIP ID",
                "POLICY NO",
                "INSURANCE COMPANY",
                "STATUS",

            ]}
            token={token}
            updateData={updateData}
            uploadFile={setShowPromptElement}
        />
    );
}
